import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <div>
            <h1>Techist.</h1>
            <p>@all right reserved Anoshkhan</p>
        </div>
        <div>
            <h5>Follow Us</h5>
            <div>
                <a href='https://www.linkedin.com/in/anosh-khan-b2b980222/' target={'blank'}>Linkedin</a>
                <a href='https://github.com/Anoshkhan'  target={'blank'}>Github</a>
                <a href="https://www.facebook.com/profile.php?id=100085882712254"  target={'blank'}>Facebook</a>
            </div>
        </div>
    </div>
  )
}

export default Footer